function nonEmpty(value: string | undefined) {
	return (value || '').trim() !== '';
}

export function getAddressLines(address: import('~/utils/models').AddressData) {
	return [
		[address.supplementaryLine1, address.supplementaryLine2, address.supplementaryLine3, ].filter(nonEmpty).join(' '),
		[address.houseNumber, address.street, ].filter(nonEmpty).join(' '),
		address.city,
		address.postcode,
	].filter(nonEmpty);
}
